import { create } from "@/store";
import { ContentEnum } from "./contentEnum";

type Open = (key: keyof ContentEnum) => void;
type OpenWithPromise = (key: keyof ContentEnum) => Promise<boolean>;

type Store = {
  isOpen: boolean;
  key: keyof ContentEnum | null;
  resolver: ((value: boolean) => void) | null;
  open: Open;
  openWithPromise: OpenWithPromise;
  close: Cb;
};

export const useMonitoringDialog = create<Store>()((set) => ({
  isOpen: false,
  key: null,
  resolver: null,
  open(key) {
    set({ isOpen: true, key });
  },
  openWithPromise(key) {
    const promise = new Promise<boolean>((resolve) => {
      set({
        isOpen: true,
        key,
        resolver: (value) => {
          resolve(value);
          set({ isOpen: false, key: null });
        }
      });
    });
    return promise;
  },
  close() {
    set({ isOpen: false, key: null });
  }
}));
